import React from "react";
import { Star, Quote } from "lucide-react";
import { REVIEWS, COMPANY } from "../mock";

export default function Reviews() {
  return (
    <section id="reviews" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-block px-3 py-1 rounded-full bg-sky-100 text-[#0a4f8a] text-xs font-bold uppercase tracking-wider mb-3">
            Reviews
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0a4f8a] mb-3">
            Loved by Sydney Locals
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 items-start">
          {REVIEWS.map((r, i) => (
            <div
              key={i}
              className="relative bg-gradient-to-br from-white to-sky-50 border border-slate-100 rounded-2xl shadow-sm card-lift overflow-hidden"
            >
              {r.image && (
                <div className="w-full overflow-hidden">
                  <img
                    src={r.image}
                    alt={r.imageAlt || `Plumbing work by ${r.name}`}
                    loading="lazy"
                    className="w-full h-56 object-cover hover:scale-105 transition-transform duration-500"
                    data-testid={`review-image-${i}`}
                  />
                </div>
              )}
              <div className="p-6 relative">
                <Quote className="absolute top-4 right-4 text-sky-100" size={40} />
                <div className="flex items-center gap-2 mb-3">
                  <div className="relative inline-flex">
                    {/* Background gray stars */}
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, idx) => (
                        <Star key={idx} size={16} className="text-slate-300" />
                      ))}
                    </div>
                    {/* Foreground yellow stars clipped to rating */}
                    <div
                      className="absolute top-0 left-0 flex items-center gap-1 overflow-hidden"
                      style={{ width: `${(r.rating / 5) * 100}%` }}
                    >
                      {[...Array(5)].map((_, idx) => (
                        <Star
                          key={idx}
                          size={16}
                          className="fill-yellow-400 text-yellow-400 shrink-0"
                        />
                      ))}
                    </div>
                  </div>
                  <span className="text-xs font-bold text-slate-600">{r.rating}</span>
                </div>
                <p className="text-slate-700 mb-5 relative z-10">“{r.text}”</p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#0a4f8a] text-white flex items-center justify-center font-bold">
                    {r.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-bold text-slate-800 text-sm">{r.name}</div>
                    <div className="text-xs text-slate-500">{r.suburb}, Sydney</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
